import React, { Component } from 'react';
import FormItem from '../../components/FormItem/index';
import { Form, Input, Button, message, Checkbox } from 'antd';
import PreviewUploadComponent from '../../components/Upload/previewImg';
import services from '../../services/api';

const { TextArea } = Input;
class PicturesAdd extends Component {
  constructor() {
    super();
    this.state = {
      detail: {}
    };
    this.actionType = 'add';
    this.type = '';
    this.id = '';
    this.api = 'pictures';
  }

  componentDidMount() {
    if (this.props.actionType) {
      this.actionType = this.props.actionType;
      if (this.actionType === 'update') {
        this.id = this.props.record.id;
        this.getDetail();
      }
    } else {
      if (this.props.location.pathname.indexOf('edit') !== -1) {
        this.actionType = 'update';
        this.id = this.props.match.params.id;
        this.getDetail();
      }
      this.type = this.props.match.params.type;
    }
  }

  /**获取详情 */
  getDetail = () => {
    services[this.api].queryOne({ id: this.id }).then(data => {
      if (data.code === 0) {
        this.setState({
          detail: data.data
        });
        this.props.form.setFieldsValue({
          title: data.data.title,
          des: data.data.des,
          orders: data.data.orders,
          is_top: data.data.is_top === 1 ? true : false,
          image: { fileUrl: data.data.image }
        });
      } else {
        message.error(data.msg);
      }
    });
  };

  /** 获取到列表url  */
  getListUrl = () => {
    const addUrlReg = /.+(?=\/add)/;
    const editUrlReg = /.+(?=\/\d+\/edit)/;
    if (this.props.location.pathname.match(addUrlReg) !== null) {
      return this.props.location.pathname.match(addUrlReg)[0];
    }
    if (this.props.location.pathname.match(editUrlReg) !== null) {
      return this.props.location.pathname.match(editUrlReg)[0];
    }
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      console.log(values);
      const params = {
        ...values,
        is_top: values.is_top ? 1 : 0,
        orders: values.orders ? parseInt(values.orders, 10) : 999,
        image: values.image.fileUrl,
        ads_id: this.props.adsId
      };
      if (this.actionType === 'update') {
        params.id = this.id;
      }
      if (!err) {
        services[this.api][this.actionType](params).then(data => {
          if (data.code === 0) {
            message.success(data.msg);
            this.props.closeModal({ adsId: this.props.adsId });
          } else {
            message.error(data.msg);
          }
        });
      }
    });
  };

  render() {
    const formItems1 = [
      {
        label: {
          label: '名称',
          className: 'tantuer-form-item'
        },
        name: 'title',
        options: {
          initialValue: '',
          rules: [{ required: true, message: '请输入名称' }]
        },
        component: <Input placeholder="名称" className="large" />,
        children: [
          {
            name: 'is_top',
            options: {
              valuePropName: 'checked',
              initialValue: ''
            },
            component: <Checkbox>置顶</Checkbox>
          }
        ]
      },

      {
        label: {
          label: '排序',
          className: 'tantuer-form-item'
        },
        name: 'orders',
        options: {
          initialValue: ''
        },
        component: (
          <Input placeholder="数字越小越靠前，默认999" className="default" />
        )
      },
      {
        label: {
          label: '链接地址',
          className: 'tantuer-form-item'
        },
        name: 'url',
        options: {
          initialValue: ''
        },
        component: <Input placeholder="链接地址" className="default" />
      },

      {
        label: {
          label: '描述',
          className: 'tantuer-form-item'
        },
        name: 'des',
        options: {
          initialValue: ''
        },
        component: <TextArea placeholder="描述" className="default" />
      }
    ];

    const formItems2 = [
      {
        label: {
          label: '图片',
          className: 'tantuer-form-item'
        },
        name: 'image',
        options: {
          initialValue: { fileUrl: '' }
        },
        component: <PreviewUploadComponent />
      }
    ];

    return (
      <div>
        <Form onSubmit={this.handleSubmit} className="login-form">
          <div className="tantuer-field-area">
            {formItems1.map(item => {
              return (
                <FormItem key={item.name} form={this.props.form} item={item} />
              );
            })}
          </div>
          <div className="tantuer-field-area">
            {formItems2.map(item => {
              return (
                <FormItem key={item.name} form={this.props.form} item={item} />
              );
            })}
          </div>

          <Button
            type="primary"
            htmlType="submit"
            className="login-form-button"
          >
            提交
          </Button>
        </Form>
      </div>
    );
  }
}

export default Form.create()(PicturesAdd);
